import { InjectionToken } from '@angular/core';

export interface AssetJsonServerReader {
  readJson<T>(url: string): Promise<T>;
}

export const ASSET_JSON_SERVER_READER =
  new InjectionToken<AssetJsonServerReader>('ASSET_JSON_SERVER_READER');
